export default __webpack_public_path__ + "locales/lo-LA/JavascriptSdk.json?hash=7e2d0893b9fbebcff3f4e2f4671f688a";